import { useEffect, useState } from "react";

/** Re-render every `ms` while mounted; returns Date.now(). */
export function useNow(ms = 250, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(id);
  }, [ms, active]);
  return now;
}

/** Milliseconds left until a server deadline (offset = serverNow − Date.now()). */
export function useCountdown(deadline: number | null | undefined, offset: number, paused = false, step = 200) {
  const now = useNow(step, deadline != null && !paused);
  if (deadline == null) return null;
  return Math.max(0, deadline - (now + offset));
}

export function secs(ms: number | null): number {
  return ms == null ? 0 : Math.ceil(ms / 1000);
}
